import { render, staticRenderFns } from "./riderWiseOFPReport_KSA_new.vue?vue&type=template&id=2a90ed02&"
import script from "./riderWiseOFPReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./riderWiseOFPReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports